import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const OtpContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${colors.bgOverlay};
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
`;

export const OtpContent = styled.div`
  width: 100%;
  max-width: 500px;
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const OtpTitle = styled.h6`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
`;

export const OtpDescription = styled.p`
  letter-spacing: 0.03em;
  color: ${colors.textSecondary};
  font-size: 14px;
  line-height: 23px;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
`;

export const OtpFieldsContent = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
`;

export const OtpFieldTitle = styled.p`
  font-size: 14px;
  line-height: 23px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  text-align: left;
  text-transform: uppercase;
`;

export const OtpInputContent = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 50px);
  column-gap: 10px;
  margin-top: 5px;
`;

export const OtpInputErrorDescription = styled.p`
  font-size: 14px;
  line-height: 23px;
  color: ${colors.bgDanger};
  margin-top: 5px;
`;

export const OtpInputField = styled.input`
  background: ${colors.textExGrayLight};
  border-radius: 8px;
  text-align: center;
  border: solid 1px ${props => props.error ? colors.bgDanger : colors.textExGrayLight};
  padding-top: 14px;
  padding-bottom: 14px;
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 17px;
`;

export const OtpTimerContent = styled.div`
  width: 85%;
  margin-top: 30px;
`;

export const OtpTimerButton = styled.span`
  color: ${colors.textHyperlink};
  font-size: 14px;
  cursor: pointer;
  transition: .2s;

  &:hover {
    color: ${colors.bgSecondaryHover};
  }
`;

export const OtpTimerSeconds = styled.span`
  color: ${colors.textPrimary};
  font-size: 14px;
  font-weight: 700;
  margin-left: 5px;
`;

export const OtpTimerProgressBarContent = styled.div`
  width: 85%;
  margin-top: 8px;
`;

export const OtpTimerProgressBar = styled.div`
  position: relative;
  background: ${colors.textExGrayLight};
  border-radius: 8px;
  width: 182px;
  height: 8px;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: ${props => props.timeWidth}%;
    height: 8px;
    border-radius: 8px;
    background: ${props => props.timer > 0 ? colors.bgTertiaryLight : colors.bgDanger};
  }
`;

export const OtpFooter = styled.div`
  margin-top: 50px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OtpFooterButton = styled.span`
  text-decoration: underline;
  color: ${colors.textHyperlink};
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: .2s;

  &:hover {
    color: ${colors.bgSecondaryHover};
  }
`;

export const OtpAttempts = styled.span`
  color: ${props => props.lastAttempt ? colors.bgDanger : colors.textPrimary};
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  display: block;
  width: 85%;
  margin-top: 5px;
`;
